import {XeroSignup} from './components';
import {xeroSignupReducer} from './reducers';
import {xeroSignupSaga} from './sagas';
import {register} from '@planday-corp/react-app';
import {Reducer} from 'redux';

export default register({
  id: 'xeroSignup',
  reducer: xeroSignupReducer as Reducer,
  saga: xeroSignupSaga,
})(XeroSignup);
